import { FunctionComponent, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Guid } from "../../../api/baseApi";
import { createOrganisation, CreateOrganisationRequest, deleteOrganisation, getOrganisationsList, Organisation, updateOrganisation } from "../../../api/organisationsApi";
import { Button } from "../../components/Button";
import { FormInput, FormRow } from "../../components/formRow/FormRow";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import IconButton from "../../components/iconButton/IconButton";
import { RightModal } from "../../components/sideModal/Modal";
import InnerLayout from "../innerLayout/InnerLayout";

interface OrganisationsProps extends RouteComponentProps<any> {
    logOut: () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

const Organisations: FunctionComponent<OrganisationsProps> = (props: OrganisationsProps) => {
    let [isLoading, setIsLoading] = useState(false);
    let [showModal, setShowModal] = useState<boolean>(false);
    let [name, setName] = useState<string>("");
    let [nameError, setNameError] = useState<boolean>(false);
    let [organisations, setOrganisations] = useState<Organisation[]>([]);
    let [organisationIdForEdit, setOrganisationIdForEdit] = useState<Guid>();

    useEffect(() => {
        async function getData() {
            await updateOrganisationList();
        }

        getData();
    }, []);

    async function updateOrganisationList() {
        setIsLoading(true);
        let organisations = await getOrganisationsList();
        if (organisations.type == "succes") setOrganisations(organisations.data.items);
        setIsLoading(false);
    }

    const renderRow = (organisation: Organisation) => {
        return <tr key={organisation.id}>
            <td>{organisation.name}</td>
            <td>{new Date(organisation.createDate).toLocaleString()}</td>
            <td>
                <IconButton tooltipText="Edit" type="edit" onClick={() => { showEditModal(organisation) }}/>
                <IconButton tooltipText="Delete" type="delete" onClick={() => { removeOrganisation(organisation.id) }}/>
            </td>
        </tr>
    }

    const showCreateModal = () => {
        setShowModal(true);
    }

    const showEditModal = (organisation: Organisation) => {
        setOrganisationIdForEdit(organisation.id);
        setName(organisation.name);
        setShowModal(true);
    }

    const closeModal = () => {
        setName("");
        setNameError(false);
        setOrganisationIdForEdit(undefined);
        setShowModal(false);
    }

    const saveOrganisation = async () => {
        if (name === "") {
            setNameError(true);
            return;
        }

        let request: CreateOrganisationRequest = {
            name: name
        };

        if (organisationIdForEdit === undefined) {
            await createOrganisation(request);
        }
        else {
            await updateOrganisation(organisationIdForEdit, request);
        }

        await updateOrganisationList();
        closeModal();
    }

    const removeOrganisation = async (id: Guid) => {
        await deleteOrganisation(id);
        await updateOrganisationList();
    }

    return (
        <InnerLayout
            isCollapsed={props.isCollapsed}
            logOut={props.logOut}
            toogleCollapse={props.toogleCollapse}
            activeTab="users">
            <>
                <div className="d-flex justify-content-end align-items-center mb-20 pt-50">
                    <Button color="green" label="Create Organisation" onClick={showCreateModal} />
                </div>
                <table className="table">
                    <thead>
                        <tr>
                            <td>Name</td>
                            <td>Create Date</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        {organisations.map(it => renderRow(it))}
                    </tbody>
                </table>
                <RightModal title={organisationIdForEdit === undefined ? "Add new organisation" : "Edit organisation"}
                    show={showModal}
                    onRequestClose={closeModal}
                    >
                    <FormRow>
                        <FormInput
                            id="organisation-name"
                            title="Name"
                            isError={nameError}
                            errorMessage="Please enter organisation name"
                            onChange={e => { setName(e.target.value); setNameError(false); }}
                            value={name}
                        />
                    </FormRow>
                    <div className="modal-btn-group">
                        <Button color="green" label="Save" onClick={saveOrganisation}/>
                        <Button color="gray" label="Cancel" onClick={closeModal}/>
                    </div>
                </RightModal>
                <GlobalSpinner isShow={isLoading} />
            </>
        </InnerLayout>
    );
}

export default withRouter(Organisations);
